import { useUser } from "~/assets/js/Api/userApi";
import { fetchStoreData, getProduct } from "~/assets/js/Api/storeApi";
import Decimal from "decimal.js";

/**
 * CUSTOM HOOK FOR GREENCLUB FEATURE
 * -> CAN/SHOULD BE MOVED GLOBALLY TO HAVE ALL GREENCLUB FUNCITONALITY
 *  IN A SINGLE HOOK BUT IN THIS CASE THIS IS JUST FOR KONFIGURATOR
 * @returns Object
 */
const useGreenClub = (productId, frachiseId, alreadyDiscountedProducts = 0) => {
    const { user, isLoading: userLoading } = useUser();
    const { product, isLoading: productLoading } = getProduct(
        productId,
        frachiseId
    );
    const { store, isLoading: storeLoading } = fetchStoreData(frachiseId);

    const greenClubLoading = userLoading || productLoading || storeLoading;
    const userGreenClubMemberships = user?.membership_count || 0;
    const storeHasGreenClub = store?.membership_enabled || false;

    const hasGreenClubDiscount =
        storeHasGreenClub &&
        userGreenClubMemberships > alreadyDiscountedProducts;

    return {
        greenClubLoading,
        hasGreenClubDiscount,
        greenClubPrice: new Decimal(
            product?.greenclub_value_gross || 0
        ).toNumber(),
    };
};

export default useGreenClub;
